<template>
    <div>
        <div class="flex mt-6 px-2">
            <div class="flex-1">
                <div class="ml-2 font-semibold uppercase text-2xs">Fill</div>

                <div
                class="flex flex-col items-start">
                <div class="p-2">
                    <div class="border border-gray-300 rounded flex relative"><input type="color"
                            class="m-1.5 d-block noborder w-4 h-4 cursor-pointer box-content rounded-full border-0  "
                            :style="{ 'background-color': bgColor }" @input="setBgColor($event)"
                            @change="setBgColor($event)" :value="bgColor">
                        <div class="p-1 border-top-0 d-flex justify-content-center align-items-center border-left">
                            <svg
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
                                <path d="M13.0016 3L3 13M3 3L13.0016 13" stroke="#495057" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="flex-1">
                <div class="ml-2 font-semibold uppercase text-2xs">Border</div>

                <div
                class="flex flex-col items-start">
                <div class="p-2">
                    <div class="border border-gray-300 rounded flex relative"><input type="color"
                            class="m-1.5 d-block noborder w-4 h-4 cursor-pointer box-content rounded-full border-0  "
                            :style="{ 'background-color': borderColor }" @input="setBorderColor($event)"
                            @change="setBorderColor($event)" :value="borderColor">
                        <div class="p-1 border-top-0 d-flex justify-content-center align-items-center border-left">
                            <svg
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
                                <path d="M13.0016 3L3 13M3 3L13.0016 13" stroke="#495057" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div v-if="getActiveObj.type === 'Rectangle'" class="px-3 mt-3">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Border Radius
                </label>
                <div class="flex-1">
                    <input type="range" min='0' max='100' step='1' :value="borderRadius"  @input="borderRadiusadd" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{borderRadius}}</div>
            </div>
        </div>
        <IncedecInput :defValue="BorderWidth" :getValue="setBorderWidth" marginClass="mt-3" label="BORDER WIDTH" sublabel="" />
    </div>
</template>
<script>
import IncedecInput from '../../incedecInput.vue';
export default {
 name:"ShapesSettings",
 components:{
        IncedecInput,
},
data() {
        return {
          
            bgColor: "rgb(36, 36, 36)",
            borderColor: "rgb(36, 36, 36)",
            BorderWidth:0,
            borderRadius:0

        }
    },
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveObj :{
          handler(updatedValues) {
            debugger // eslint-disable-line no-debugger
            
            // this.lineheight = updatedValues.lineHeight;
            this.borderRadius = updatedValues.borderRadius;
            this.BorderWidth = updatedValues.borderWidth;
            this.bgColor = updatedValues.bgColor;
            this.borderColor = updatedValues.borderColor;
                
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        setBgColor(e) {
            let value = e.target.value;
            console.log(value)
                console.log(value)
                this.bgColor = value;
                this.$store.dispatch("setCurrentObjectProperties" , { bgColor: value });
        },
        setBorderColor(e) {
            let value = e.target.value;
            console.log(value)
                console.log(value)
                this.borderColor = value;
                this.$store.dispatch("setCurrentObjectProperties" , { borderColor: value });
        },
        setBorderWidth(value){
            console.log("parentValue" , value)
            this.$store.dispatch("setCurrentObjectProperties" , { borderWidth: value });
        },
        borderRadiusadd(e){
            

            let value = e.target.value;
            this.borderRadius = value;
            if(this.getActiveObj.type != "text" ){
                this.$store.dispatch("setCurrentObjectProperties" , { borderRadius: value });

            }
            
        }
    }
}
</script>

<style scoped>
.w-10 {
    width: 2.5rem;
}
.flex-1 {
  flex: 1 1;
}
.leading-4 {
    line-height: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.flex {
    display: flex;
}

.underline {
    text-decoration: underline;
}
.text-2xs {
  font-size: .625rem;
}
.noborder::-webkit-color-swatch {
    border: none;
}

.h-8 {
    height: 2rem;
}

.w-6 {
    width: 1.5rem;
}

.h-6 {
    height: 1.5rem;
}

.leading-tight {
    line-height: 1.25;
}

.bg-gray-100 {
    background-color: rgb(248 249 250);
}

.w-4 {
    width: 1rem;
}

.h-4 {
    height: 1rem;
}

.m-1\.5 {
    margin: .375rem;
}

.rounded-full {
    border-radius: 9999px;
}

.textforms.active {
    background-color: rgb(236 239 253);
    padding: .375rem;
    color: rgb(66 99 235);

}

.text-gray-700 {
    color: rgb(73 80 87);
}

.text-gray-500 {
    color: rgb(172 181 189);
}
.ml-2 {
  margin-left: .5rem;
}
.uppercase {
  text-transform: uppercase;
}
.font-semibold {
  font-weight: 600;
}
</style>